import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import React from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { valueUseRef } from "../../shared/atoms/getValueInputAtoms";
import { globalLoadingAtom, userDataSelector } from "../../shared/globalStates";
import Loading from "../Loading";
import Footer from "./Footer";
import MainBox from "./MainBox";
import SectionContainer from "./SectionContainer";
import SideBar from "./SideBar";
import SideBarCandidate from "./SidebarCandidate";

export default function Template({ children }) {
  const userData = useRecoilValue(userDataSelector);
  const loading = useRecoilValue(globalLoadingAtom);
  const setBoxUseRef = useSetRecoilState(valueUseRef);

  return (
    <React.Fragment>
      {loading && <Loading />}
      <MainBox>
        {userData ? userData.is_admin === false ? <SideBarCandidate /> : <SideBar /> : null}
        <Box
          ref={(e) => setBoxUseRef((p) => (p ? p : e))}
          sx={{
            backgroundColor: "white",
            flexGrow: 1,
            height: "100vh",
            position: "relative",
            overflow: "auto",
          }}>
          <Toolbar />
          <SectionContainer>{children}</SectionContainer>
          <Footer sx={{ pt: 4 }} />
        </Box>
      </MainBox>
    </React.Fragment>
  );
}
